export default "__VITE_ASSET__DVTefAS7__"